import { ResOrderDetails } from "./ResOrderDetails.model";

export class ResOrders {
    RowIndex: number;
    Total: number;
    OrderCode: string;
    TableCode : string;
    CustomerNote : string;
    StatusName : string;
    RestaurantUserName : string;
    OrderTypeName: string;
    AreaCode : string;
    AreaName : string;
    OrderTaker: string;
    UserID : number;
    ResUserID : number;
    TimeRequired : number;
    OrderType : number;
    Status : number;
    OrderTime : any;
    UpdationTime: any;
    Hour: number;
    Minutes: number;
    Seconds: number;
    CompletionTime : any;
    RecordTimeStamp : any;
    OrderRecordTimeStamp : Date;
    IsPaid: boolean;
    IsAutoNumbering: boolean;
    RefOrderNumber: string;
    PaymentMode: string;
    PaymentName: string;
    GlobalDiscountRate: number;
    GlobalDiscountAmount: number;
    NetAmount: number;
    GrandAmount: number;
    IsInserting: boolean;
    GoDownCode: string;
    ResOrderDetailList: ResOrderDetails[];
    CompanyName: string;
    CompanyAddress: string;
    CompanyLogo: string;
    PrinterName: string;
    PhoneNumber: string;
    FaxNumber: string;
    CustomerName: string;
    Phone: string;
    Address: string;
    DeliveryCharges: number;
    NTN: string;
    GlobalTaxRate: number;
    GlobalTaxAmount: number;
    GlobalTaxCode: string;
    GlobalTaxGroupID: string;
    GlobalTaxGroupName: string;
    ProductDiscountTotal: number;
    RestaurantSalesAgentCode: string;
     GlobalTax1Code: string;
    GlobalTax1Name: string;
    GlobalTax1Rate: number;
    GlobalTax1Amount: number;

    GlobalTax2Code: string;
    GlobalTax2Name: string;
    GlobalTax2Rate: number;
    GlobalTax2Amount: number;

    AdvancePaidInCash: number;
    RoundOffAmount: number;
    RoundOffDifference: number;

     NumOfPerson?: number;
    SupervisorRemarks?: string;

}

export interface PrintRequests {
    html: string;
    printerName: string;
}